import { Button } from "antd";
import "./style.scss";
import mano from '../../assets/celular y mano.png'
import playStore from '../../assets/icons/googleplay.svg'
import appStore from '../../assets/icons/appStore.svg'

function Suscribete() {
  return (
    <div id="id_suscribete">
      <div className="cls_container_body">
        <h2 className="cls_suscribete_title_effect">
          DESCARGA AQUI <span>DOCTORAPP</span>
        </h2>

        <div className="cls_cotainer_store">
          <a 
            href="https://play.google.com/store/apps/details?id=com.automatizate.doctorapp2025&pcampaignid=web_share"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={playStore} alt="Google Play" />
          </a>

          <a 
            href="https://apps.apple.com/pe/app/doctorapp/id6755206134"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={appStore} alt="App Store" />
          </a>
        </div>

      </div>

      <div className="cls_imagen cls_suscribete_imagen_effect">
        <img src={mano} alt="imagenMano" />
      </div>
    </div>
  );
}

export default Suscribete;